const exceptionsTranslations = {
  es: {
    table: {
      breadcrumbs: {
        title: 'Excepciones',
        description: 'Administración de Excepciones del alumno',
      },
      headers: {
        name: 'Nombre',
        identification: 'Identificación',
        career: 'Carrera',
        startDate: 'Inicio',
        status: 'Estado',
      },
      actions: {
        validate_contact: 'Verificar usuario',
      },
    },
    popup:{
      title:'Verificar usuario',
      label:'Ingrese un email para verificar si el usuario se encuentra registrado:'
    },
    warning: 'Usuario no encontrado en HubSpot.',
    errorMessage: {
      exceptionEmail: 'Ocurrió un error al encontrar el email ingresado.',
      exceptionUserAra: 'Ocurrió un error al registrar el usuario.',
      },
    validations: {
        leadEmailFormat: 'Ingrese un formato de email válido',
        emailInput :'Ingrese un email',
        warnings: {
          emailNotFound: 'El email ingresado no esta registrado en el sistema ¿Desea continuar?',
        },
        success:{
          successUserAra:'Se ha registrado correctamente el usuario.',
          successEmail:'El email ingresado se encuentra registrado ¿Desea continuar?'
        }
    },
  },
};

export default exceptionsTranslations
